import { configureStore } from '@reduxjs/toolkit';
import ratedReducerFunction from "./ratedPolicyStore";
import policyReducerFunction from "./policyStore";
import issuedPolicyReducerFunction from './issuedPolicyStore';
import systemFlagsReducerFunction from './systemflagsStore';
import rateCycleReducerFunction from './ratecycleStore';

const store = configureStore({
    reducer:{
        policyReducer:              policyReducerFunction,
        ratedPolicyReducer:         ratedReducerFunction,
        issuedPolicyReducer:        issuedPolicyReducerFunction,
        rateCycleReducer:        rateCycleReducerFunction,
        systemFlagsPolicyReducer:   systemFlagsReducerFunction
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({...getDefaultMiddleware,
        immutableCheck: false,
        serializableCheck:false
    })
});

export default store;